// API helper per le categorie (tenant-portal)
import { apiFetch } from './client';

export async function fetchCategories() {
    try {
        // Prima tenta l'endpoint /api/menu/snapshot che restituisce tutto in un colpo solo
        const res = await apiFetch('/api/menu/snapshot');
        if (res.ok) {
            const data = await res.json();
            return data.categories; // Restituisce solo le categorie
        }

        // Fallback: endpoint originale
        const fallback = await apiFetch('/api/category');
        if (!fallback.ok) throw new Error('Errore caricamento categorie');
        return fallback.json();
    } catch (error) {
        console.error('Errore caricamento categorie:', error);
        throw error;
    }
}

export async function createCategory(data: any) {
    const res = await apiFetch('/api/category', {
        method: 'POST',
        body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error('Errore creazione categoria');
    return res.json();
}

export async function updateCategory(id: number | string, data: any) {
    const res = await apiFetch(`/api/category/${id}`, {
        method: 'PUT',
        body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error('Errore aggiornamento categoria');
    return res.json();
}

export async function deleteCategory(id: number | string) {
    const res = await apiFetch(`/api/category/${id}`, { method: 'DELETE' });
    if (!res.ok) throw new Error('Errore eliminazione categoria');
    return true;
}

export async function reorderCategories(items: { id: number | string; sortOrder: number }[]) {
    const res = await apiFetch('/api/category/reorder', {
        method: 'PUT',
        body: JSON.stringify(items)
    });
    if (!res.ok) throw new Error('Errore riordino categorie');
    return true;
}
